import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, UseFormReturn } from 'react-hook-form'
import { object } from 'yup'

import { usePersonGeneralData } from 'hooks'
import { useGetAddressByCep } from 'hooks/useGetAddressByCep'
import { ModifiedAddress } from 'models/Auth'
import { addressSchema } from 'utils/schemas'

export type AddressFormMethods = UseFormReturn<{ address: ModifiedAddress }>

type FormMethods = {
  formMethods: AddressFormMethods
  userData: ReturnType<typeof usePersonGeneralData>['userData']
  hasAddressData: boolean
}

const schema = object().shape({
  address: addressSchema
})

export const useEditAddressForm = (): FormMethods => {
  const { userData, hasAddressData } = usePersonGeneralData()
  
  const formMethods = useForm({
    criteriaMode: 'all',
    mode: 'all',
    resolver: yupResolver(schema),
    defaultValues: {
      address: {
        cep: userData.address_data?.cep || '',
        address: userData.address_data?.address || '',
        number: userData.address_data?.address_number || '',
        complement: userData.address_data?.complement || '',
        neighborhood: userData.address_data?.neighborhood || '',
        city: userData.address_data?.city || '',
        state: userData.address_data?.state || ''
      }
    }
  })

  const { setValue, setError, watch } = formMethods
  const cep = watch('address.cep')
  const isSameCEP = userData.address_data?.cep === cep
  
  useGetAddressByCep({ 
    cep,
    enabled: cep?.length === 8 && !isSameCEP,
    onSuccess: (data) => {
      setValue('address.address', data.address, { shouldValidate: true })
      setValue('address.neighborhood', data.neighborhood, { shouldValidate: true })
      setValue('address.city', data.city, { shouldValidate: true })
      setValue('address.state', data.state, { shouldValidate: true })
    },
    onError: () => {
      setError('address.cep', {
        type: 'manual',
        message: 'CEP inválido'
      })
      setValue('address.address', '')
      setValue('address.neighborhood', '')
      setValue('address.city', '')
      setValue('address.state', '')
    }
  })

  return {
    formMethods,
    userData,
    hasAddressData
  }
}